import { Mutation } from "@apollo/client/react/components";
import { useRouter } from "next/router";
import React from "react";
import SetGroupAwards from "~/lib/mutations/SetGroupAwards";
import {
  ISetGroupAwardsMutation,
  ISetGroupAwardsMutationVariables,
} from "~/lib/mutations/__generated__/SetGroupAwards.generated";
import AwardsBox from "~/components/awards/AwardsBox";
import { Margin } from "~/components/spacings";
import { IGroupProps } from "~/components/group/IGroupProps";

export default function GroupAwards({ group }: IGroupProps) {
  const router = useRouter();
  return (
    <Margin mt={24}>
      <Mutation<ISetGroupAwardsMutation, ISetGroupAwardsMutationVariables> mutation={SetGroupAwards}>
        {(setAwards) => (
          <AwardsBox
            readOnly={!group.viewerIsMember}
            onAddLink={() => {
              router.push("/groups/[groupSlug]?content=newsworthy", `/groups/${group.slug}/newsworthy`);
              window.scrollTo({
                top: 0,
              });
            }}
            awards={group.awards}
            onSubmit={(values) => {
              return setAwards({
                variables: {
                  groupId: group._id,
                  awards: values.awards.map(({ _id, objectID }: any) => _id || objectID),
                },
                optimisticResponse: {
                  __typename: "Mutation",
                  setGroupAwards: {
                    __typename: "Group",
                    _id: group._id,
                    awards: values.awards.map(({ _id, objectID, name }: any) => ({
                      _id: _id || objectID,
                      name,
                    })),
                  },
                },
              });
            }}
          />
        )}
      </Mutation>
    </Margin>
  );
}
